﻿export class OrganizerShare {
    public Email: string;
    public PDID: string;
}